import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { usePermissions } from '~/entities/viewer'
import { Counterparty } from '~/shared/api'
import { AsyncGrid } from '~/shared/ui/AsyncGrid'
import type { FetchRowsFn } from '~/shared/ui/AsyncGrid/types'
import { Button } from '~/shared/ui/Buttons'
import { PlusIcon } from '~/shared/ui/Icons'
import { columns } from './columns'
import { GridRow } from './types'

export const ListCounterparties = () => {
  const { t } = useTranslation()
  const { canRepairOrdersUpdate } = usePermissions()

  const fetchRows = useCallback<FetchRowsFn<GridRow>>(
    async (page, pageSize, filters = []) => {
      let builder = Counterparty.limit(pageSize).orderBy('-createdAt')

      filters.forEach(({ key, value }) => {
        builder = builder.where(key, value)
      })

      const response = await builder.get(page)

      const data = response.getData()
      const rows = data.map((counterparty) => ({
        ...counterparty.getAttributes(),
        id: counterparty.getApiId() as string,
      }))

      const httpClientResponse = response.getHttpClientResponse()
      const axiosResponse = httpClientResponse?.getUnderlying()
      const total = axiosResponse?.data?.meta?.page?.total || 0

      return {
        rows,
        total,
      }
    },
    [],
  )

  return (
    <AsyncGrid<GridRow>
      gridKey='counterparties'
      fetchRows={fetchRows}
      columns={columns}
      title={t('counterparties')}
      headerExtra={
        <Button
          startDecorator={<PlusIcon />}
          to='new'
          show={canRepairOrdersUpdate}
        >
          {t('button.add')}
        </Button>
      }
    />
  )
}
